import { useEffect, useState } from "react";
import { PublicShell } from "@/pages/PublicSalon";
import { BlockRenderer } from "@/components/builder/BlockRenderer";

// Iframe preview target. Receives postMessage from parent (PageBuilder)
// and renders the page using PublicShell + BlockRenderer.
export default function BuilderPreview() {
  const [state, setState] = useState(null);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    const onMsg = (e) => {
      if (!e.data || e.data.__mv !== "preview") return;
      if (e.data.type === "state") setState(e.data.payload);
      if (e.data.type === "select") setSelectedId(e.data.id);
    };
    window.addEventListener("message", onMsg);
    // ready
    window.parent?.postMessage({ __mv: "preview", type: "ready" }, "*");
    return () => window.removeEventListener("message", onMsg);
  }, []);

  if (!state) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm" style={{ background: "var(--mv-canvas)", color: "var(--mv-text-muted)" }}>
        Lade Vorschau ...
      </div>
    );
  }
  const { salon, theme, header, footer, blocks, forms, services, staff, loyalty, addons, categories } = state;
  const click = (id) => window.parent?.postMessage({ __mv: "preview", type: "click", id }, "*");

  return (
    <PublicShell salon={salon} theme={theme} header={header} footer={footer}>
      <div className="max-w-6xl mx-auto px-6 lg:px-12 py-8 lg:py-16">
        {(blocks || []).map((b) => (
          <div
            key={b.id}
            onClick={(e) => { e.stopPropagation(); click(b.id); }}
            style={{
              outline: selectedId === b.id ? "2px solid #C87A5F" : "1px dashed transparent",
              outlineOffset: "4px",
              cursor: "pointer",
              borderRadius: "4px",
            }}
            onMouseEnter={(e) => { if (selectedId !== b.id) e.currentTarget.style.outline = "1px dashed #C87A5F"; }}
            onMouseLeave={(e) => { if (selectedId !== b.id) e.currentTarget.style.outline = "1px dashed transparent"; }}
          >
            <BlockRenderer block={b} theme={theme} forms={forms} services={services || []} staff={staff || []} addons={addons || []} categories={categories || []} loyalty={loyalty} />
          </div>
        ))}
        {(blocks || []).length === 0 && (
          <div className="border-2 border-dashed rounded-xl p-12 text-center" style={{ borderColor: "var(--mv-border)", color: "var(--mv-text-muted)" }}>
            Leere Seite – fügen Sie Komponenten hinzu
          </div>
        )}
      </div>
    </PublicShell>
  );
}
